<div class="col-md-12 action-buttons text-right gen-button">
    <div class="gen-input">
        <input [(ngModel)]="activationCode" kendoTextBox />
        <button [disabled]="disableActivateUserButton" (click)="activateUser()" class="btn btn-primary">{{l(actionButtonStructure.componentSettings.actionButtonLabelKey)}}</button>
    </div>
</div>